<template>
  <div class="employee-compliance-filter">
    <button
        data-toggle="modal"
        data-target="#employeeComplianceFilter"
        class="btn link-filter font-weight-bold p-0"
    >
      <img
          src="/images/Filters.svg"
          alt="cog-icon"
          class="ml-1 mb-1 icon-filter"
      />
      Filters
    </button>
    <div
        class="modal fade"
        id="employeeComplianceFilter"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content p-2">
          <div class="modal-body">
            <div
                class="d-flex justify-content-between align-items-center"
            >
              <div class="modal-name">Users Filters</div>
              <button
                  class="btn btn-cancel font-weight-bold p-0 float-right"
                  data-dismiss="modal"
                  aria-label="Close"
              >
                Cancel
              </button>
            </div>
            <div class="mb-4">
              <input
                  placeholder="Enter designation, name or email..."
                  class="form-control mt-4"
                  type="text"
                  v-model="filter.term"
              />
            </div>
            <div class="mb-4">
              <div class="wfh-v-select-override wfh-sm">
                <v-select
                    placeholder="Select a group"
                    :options="teamOptions"
                    :filterable="false"
                    :clearable="false"
                    v-model="filter.teamId"
                    :reduce="(item) => item.code"
                >
                  <template #search="{ attributes, events }">
                    <input
                        class="vs__search"
                        :required="!filter.teamId"
                        v-bind="attributes"
                        v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </div>
            <div class="mb-2 mt-4">
              <v-ctk-datepicker
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="filter.date"
                  label="Date"
                  :no-button-now="true"
                  :auto-close="true"
                  :only-date="true"
                  :range="true"
              />
            </div>

            <div class="row mt-5">
              <div class="col-6">
                <button
                    class="btn btn-clear"
                    :disabled="isDisableResetFilter"
                    @click="resetFilter()"
                >
                  Clear filters
                </button>
              </div>
              <div class="col-6">
                <button
                    class="btn btn-filter"
                    :disabled="isDisableResetFilter"
                    @click="applyFilter()"
                >
                  Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import vSelect from "vue-select"

export default {
  components: {vSelect},

  props: ['value'],

  data () {
    return {
      teams: [],
      filter: {
        teamId: null,
        term: '',
        date: '',
      },
      defaultFilter: {
        term: '',
        date: '',
      },
    };
  },

  computed: {
    isDisableResetFilter () {
      return (
          JSON.parse(JSON.stringify(this.filter)) ===
          JSON.parse(JSON.stringify(this.defaultFilter))
      );
    },

    teamOptions() {
      const teams = this.teams.map((item) => {
        return {
          label: item.name,
          code: item.id,
        }
      })

      if (teams.length === 1 && !this.task.id) {
        this.task.team_id = teams[0].code
      }

      return teams
    },
  },

  watch: {
    value: {
      deep: true,
      handler (val) {
        this.filter = val;
      },
    },

    filter: {
      deep: true,
      handler (val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    resetFilter () {
      this.filter = this.defaultFilter;
    },

    applyFilter () {
      this.$emit('filter');
      jQuery('#employeeComplianceFilter').modal('hide');
    },

    async getUserGroup() {
      await axios.get(`/groups`).then((data) => {
        data.data.data.forEach((item) => {
          const group = _.find(this.teams, {
            id: item.id,
          })

          if (!group) {
            this.teams.push(item)
          }
        })
      })
    },
  },

  mounted () {
    this.filter = this.value;
    this.getUserGroup();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.employee-compliance-filter {
  .icon-filter {
    color: #303030;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }

  .modal-name {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
  }

  .btn-cancel {
    color: #0db4e6;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }

  .modal-label {
    color: #808fa4;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    line-height: 22px;
  }

  .btn-filter {
    height: 56px;
    background-color: #000;
    width: 100%;
    color: #fff;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    border-radius: 4px;
  }

  .btn-clear {
    height: 56px;
    width: 100%;
    color: #28282e;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    border: 1px solid #28282e;
    border-radius: 4px;
  }

  .link-filter {
    color: #303030;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
}

$color-accent: #5145ff;

.text-accent {
  color: $color-accent;
}

.bg-accent {
  background-color: $color-accent;
}

@include media-breakpoint-down(sm) {
  .modal-dialog {
    margin: 0;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    max-width: 100%;
  }
}
</style>
